import _get from 'lodash/get';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';

import { FEE_TYPE, FEE_TYPE_VALUE, PAYER } from './stubs';

const DEDUCTIONS_KEY = 'deductions.domestic.entity_types.return';

/**
 * @param {any} data
 * @returns {import("zod").z.infer<typeof import('./stubs').FORM_SCHEMA>}
 */
export const createFormData = data => {
  const deductions = _get(data, DEDUCTIONS_KEY);
  const feeType = _get(deductions, 'charge_type', FEE_TYPE_VALUE.FLAT_FEE);
  const feeAmount = _get(deductions, 'flat_fee', 0);
  const isFlatFee = feeType === FEE_TYPE_VALUE.FLAT_FEE;

  return {
    ...data,
    feeAmount,
    feeType: isFlatFee ? FEE_TYPE.FLAT_FEE : FEE_TYPE.CARRIER_FEE,
    paidBy: isFlatFee && feeAmount <= 0 ? PAYER.MERCHANT : PAYER.SHOPPER
  };
};

/** @param {import("zod").z.infer<typeof import('./stubs').FORM_SCHEMA>} data */
export const createPayload = data => {
  const payload = _cloneDeep(data);

  const paidBy = _get(payload, 'paidBy', PAYER.MERCHANT);
  const feeType = _get(payload, 'feeType', FEE_TYPE.FLAT_FEE);
  const feeAmount = _get(payload, 'feeAmount', 0);
  const chargeType = _get(FEE_TYPE_VALUE, feeType, FEE_TYPE_VALUE.FLAT_FEE);
  const deductions = _get(payload, DEDUCTIONS_KEY, {});
  const isFlatFee = feeType === FEE_TYPE.FLAT_FEE;
  const doesShopperPay = paidBy === PAYER.SHOPPER;

  delete payload.id;
  delete payload.paidBy;
  delete payload.feeType;
  delete payload.feeAmount;

  const deductionsData = {
    ...deductions,
    flat_fee: doesShopperPay && isFlatFee ? +feeAmount : 0,
    charge_type: doesShopperPay ? chargeType : FEE_TYPE_VALUE.FLAT_FEE
  };

  _set(payload, 'deductions.domestic.entity_types.return', deductionsData);
  _set(payload, 'deductions.domestic.entity_types.exchange', deductionsData);

  return payload;
};
